import { render, staticRenderFns } from "./FamiliarPage.vue?vue&type=template&id=e31404d6"
import script from "./FamiliarPage.js?vue&type=script&lang=js&external"
export * from "./FamiliarPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports